// 職員画面用ポップアップ
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Props {
  toggleShow: boolean;
  text: string;
  btn1_label: string;
  btn1_css: string;
  btn1_func: () => void;
  btn2_label?: string;
  btn2_css?: string;
  btn2_func?: () => void;
}

const PopupStaff: React.FC<Props> = ({
  toggleShow,
  text,
  btn1_label,
  btn1_css,
  btn1_func,
  btn2_label,
  btn2_css,
  btn2_func,
}) => {
  return (
    <Modal show={toggleShow} centered backdrop="static" keyboard={false}>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <a className={`btn btn-mini  ${btn1_css}`} onClick={btn1_func}>
          {btn1_label}
        </a>
        {btn2_label && (
          <a className={`btn btn-mini  ${btn2_css}`} onClick={btn2_func}>
            {btn2_label}
          </a>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PopupStaff;
